import { render, staticRenderFns } from "./FatturazioneNumeratoriList.vue?vue&type=template&id=75679948"
import script from "./FatturazioneNumeratoriList.vue?vue&type=script&lang=js"
export * from "./FatturazioneNumeratoriList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports